// @flow
import React from 'react';
import type {Node} from 'react';
import Icon from '../Icon/Icon';

import type {IconName} from '../Icon/Icon';

import './IconButton.less';

type Props = {
    icon: IconName,
    disabled?: boolean,
    onClick?: () => mixed,
    children?: Node
};

const noop = function() {};

const IconButton = ({icon, disabled, onClick = noop, children}: Props) => (
    <button
        className="IconButton btn"
        disabled={disabled}
        onClick={onClick}
        data-wdio={`IconButton__${icon}`}
    >
        <Icon name={icon} color={disabled ? 'lightgray' : 'link-color'} />
        {children}
    </button>
);

export default IconButton;
